import { FronteggContext } from '@frontegg/rest-api';
import { axiosAmbient } from 'src/lib/axios';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import {
  allTemplatesSlice,
  preBuiltTemplatesLoadingSlice,
  preBuiltTemplatesMappingSlice,
} from '../slices';

export const getPreBuiltTemplatesMappingAction = () => {
  return async (dispatch) => {
    try {
      dispatch(preBuiltTemplatesLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await axiosAmbient.get('/templates/mapping', {
        headers,
      });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(preBuiltTemplatesMappingSlice(response));
      }
    } catch (error) {
      showToastError(error);
    } finally {
      dispatch(preBuiltTemplatesLoadingSlice(false));
    }
  };
};

export const listAllTemplatesAction = () => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await axiosAmbient.get('/templates/all', {
        headers,
      });
      const response = result?.data?.templates;
      if (result?.status === 200 && response) {
        dispatch(allTemplatesSlice(response));
      }
    } catch (error) {
      showToastError(error);
    }
  };
};

export const updatePreBuiltTemplatesMappingAction = (
  plan_id,
  template_ids,
  setIsOpen
) => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const payload = {
        plan_id: plan_id,
        template_ids: template_ids,
      };
      const result = await axiosAmbient.put('/templates/mapping', payload, {
        headers,
      });
      if (result?.status === 200) {
        showToastSuccess('Template mapping updated successfully');
        dispatch(getPreBuiltTemplatesMappingAction());
        setIsOpen(false);
      }
    } catch (error) {
      showToastError(error);
    }
  };
};

export const addNewPreBuiltTemplatesMappingAction = (
  plan_ids,
  setIsOpen,
  setSelectedPlansToAdd
) => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const payload = {
        plan_ids: plan_ids,
      };
      const result = await axiosAmbient.post('/templates/mapping', payload, {
        headers,
      });
      if (result?.status === 201) {
        showToastSuccess('Template mapping added successfully');
        dispatch(getPreBuiltTemplatesMappingAction());
        setIsOpen(false);
        setSelectedPlansToAdd([]);
      }
    } catch (error) {
      showToastError(error);
    }
  };
};

export const updateTemplateSpecialtiesAction = (template_id, specialty_ids) => {
  return async (dispatch) => {
    try {
      dispatch(preBuiltTemplatesLoadingSlice(true));
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const payload = {
        template_id: template_id,
        specialty_ids: specialty_ids,
      };
      const result = await axiosAmbient.put('/templates/specialties', payload, {
        headers,
      });
      if (result?.status === 200) {
        showToastSuccess('Template specialties updated successfully');
        // Refresh the templates list
        dispatch(listAllTemplatesAction());
        return true;
      }
    } catch (error) {
      showToastError('Failed to update template specialties');
      console.error('Error updating template specialties:', error);
      return false;
    } finally {
      dispatch(preBuiltTemplatesLoadingSlice(false));
    }
  };
};
